import React from 'react';
import { motion } from 'framer-motion';
import { Shield, Lock, Award, CheckCircle2 } from 'lucide-react';

const Compliance = () => {
  const badges = [
    { icon: Shield, label: 'HIPAA Compliant' },
    { icon: Lock, label: 'SOC 2 Certified' },
    { icon: Award, label: 'AAPC/CPC Certified' },
    { icon: CheckCircle2, label: '256-bit Encryption' },
  ];

  return (
    <section className="py-20 bg-gradient-to-r from-[#1e3a8a]/5 to-[#14b8a6]/5 border-y border-slate-100">
      <div className="container mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-100px' }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <h3 className="text-3xl font-bold text-slate-900 mb-4">
            Enterprise-Grade Security & Compliance
          </h3>
          <p className="text-slate-600 text-lg">
            Your patient data is protected with industry-leading security standards
          </p>
        </motion.div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {badges.map((badge, index) => {
            const Icon = badge.icon;
            return (
              <motion.div
                key={index}
                initial={{ opacity: 0, scale: 0.8 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true, margin: '-100px' }}
                transition={{ delay: index * 0.1, duration: 0.4 }}
                whileHover={{ scale: 1.1 }}
                className="flex flex-col items-center text-center"
              >
                <div className="w-20 h-20 rounded-2xl bg-white border-2 border-slate-200 flex items-center justify-center mb-4 shadow-sm">
                  <Icon size={36} className="text-[#1e3a8a]" />
                </div>
                <div className="font-semibold text-slate-900">{badge.label}</div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Compliance;
